var map = {
	"./accidental-loss.png": "f0a4",
	"./bicycles.png": "8cec",
	"./home-emergency.png": "13ed",
	"./legal-expenses.png": "68cc",
	"./mobile-phones.png": "78e9",
	"./personal-possessions.png": "30a7",
	"./valuable-items.png": "e5b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "17b4";